<template>
  <div>
    <!-- <topnav /> -->
    <div class="annotate-container">
      <div class="annotate-title">
        <router-link to="/tasklist"><button class="hollow-btn">返回</button></router-link>
        <button
          :style="{ background: mode === 0 ? '#cccccc' : '' }"
          @click="finishImage()"
          style="width: 100px;margin-left: 30px;"
        >
          下一张
        </button>
        <button class="hollow-btn" :disabled="!duoview" style="width: 120px;margin-left: 30px;" @click="showDuoview()">
          查看另一视角
        </button>
        <span>图片ID：{{ imageId }}</span>
        <div class="mode-btn">
          <button
            v-if="taskTypeId === 5 || taskTypeId === 6"
            class="hollow-btn"
            :class="currMode === 'point' ? 'active' : ''"
            @click="
              point();
              currMode = 'point';
            "
          >
            画框模式
          </button>
          <button
            v-if="taskTypeId === 5 || taskTypeId === 6"
            class="hollow-btn"
            :class="currMode === 'words' ? 'active' : ''"
            @click="
              words();
              currMode = 'words';
            "
            :disabled="orgAnnos.length === 0"
          >
            录入模式
          </button>
        </div>
      </div>
      <div class="annotate-content">
        <div class="annotate-image">
          <AnnoPanel
            v-if="showPanel"
            :src="url"
            ref="annopanel"
            :annos="annos"
            height="646"
            :style="{ height: '646px', background: '#fafafa' }"
            :mode="mode"
            scalable
            :separable="taskTypeMap[taskTypeId] !== 2"
            maskColor="transparent"
            @annoClick="annoClick($event)"
          ></AnnoPanel>
          <a class="icp-info" href="https://beian.miit.gov.cn" target="_blank">
            <span>沪ICP备20000777号-1</span>
          </a>
        </div>
        <div class="annotate-classes anno-option" v-if="taskTypeId !== 5 && taskTypeId !== 6">
          <div class="category-option" v-for="(item, group) of sortedClassifications" :key="group">
            <span
              class="class-option"
              :class="{ active: currClasses.includes(c.classId) }"
              v-for="c of item"
              :key="c.classId"
              @click="setClass(0, c.classId)"
            >
              {{ c.className }}
            </span>
            <div class="separate-line"></div>
          </div>
        </div>
        <div class="annotate-text anno-option" v-if="taskTypeId === 5 || taskTypeId === 6">
          <textarea v-model="sceneText" :disabled="mode === 1"></textarea>
        </div>
        <div v-show="url" class="annotate-btn">
          <div v-show="mode === 1">
            <button @click="newAnno()" style="width: 200px;margin: 0px;">新增画框</button>
            <!-- <button class="hollow-btn" @click="invalidImage()">无效</button> -->
          </div>
          <div v-show="mode === 0">
            <button :disabled="saveAnnoAble" @click="saveAnno()">保存画框</button>
            <button style="background: #c05d5d;" @click="deleteAnno()">
              {{ getDeleteName() }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="另一视角图片" :visible.sync="duoviewVisible" width="70%">
      <div v-if="duoview" style="text-align: center;">
        <img :src="duoview.url" style="max-width: 100%; max-height: 70vh; object-fit: contain;" />
        <p style="margin-top: 8px; color: #666;">{{ duoview.name }}</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ImageDetail from '@/mixins/imagedetail.js';
export default {
  data: function() {
    return {
      pageType: 'annotate',
      currMode: 'point',
    };
  },
  mixins: [ImageDetail],
  computed: {
    sortedClassifications() {
      return this.classifications.reduce((pre, cur) => {
        cur.classes.forEach(v => {
          const group = parseInt(v.groupId / 100);
          if (pre[group]) {
            pre[group].push(v);
          } else {
            pre[group] = [v];
          }
        });
        return pre;
      }, {});
    },
  },
};
</script>
<style scoped>
button {
  margin: 0px;
  height: 38px;
}
button.active {
  background-color: #5d89c0;
  color: #ffffff;
}
.mode-btn {
  display: inline-block;
  float: right;
  margin-right: 224px;
}
.mode-btn button {
  margin-left: 20px;
  width: 100px;
  outline: none;
}
.annotate-btn {
  position: absolute;
  right: 0px;
  bottom: 12px;
}
.annotate-btn div button:first-child {
  width: 100px;
  margin-right: 40px;
}
.annotate-btn div button:last-child {
  width: 60px;
}
.annotate-content {
  height: 646px;
  position: relative;
}
.annotate-image {
  box-sizing: border-box;
  margin-right: 224px;
}
.anno-option {
  position: absolute;
  right: 0px;
  top: 0px;
  width: 200px;
  height: 588px;
  padding-top: 10px;
  border: 1px solid #eeeeee;
  box-sizing: border-box;
  background: #fafafa;
  overflow: scroll;
}
.annotate-text {
  padding: 0px;
}
.annotate-text textarea {
  resize: none;
  width: 198px;
  height: 586px;
  padding: 8px;
  box-sizing: border-box;
  font-size: 18px;
}
.annotate-container {
  padding: 0px 50px 24px;
  width: 100%;
  box-sizing: border-box;
}
.annotate-title {
  margin: 16px 0px;
}
.annotate-title span {
  margin-left: 25%;
}
.annotate-title button {
  /*width: 120px;*/
  height: 30px;
}
.class-option {
  display: block;
  cursor: pointer;
  padding: 6px 12px;
  font-size: 14px;
}
.class-option.active {
  background: rgba(93, 137, 192, 0.3);
}
.category-option:last-child .separate-line {
  display: none;
}
.separate-line {
  border-top: 1px dashed #bbbbbb;
  margin: 6px;
}
.icp-info {
  display: block;
  padding-top: 12px;
  text-align: center;
  font-size: 14px;
  color: #333333;
}
</style>
